"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import { useNavigate } from "react-router-dom";
import SectionTitle from "@/components/common/section-title";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Activité de meublé de tourisme et de chambre d’hôtes"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
                <p className={"text-justify text-normal my-4"}>
                    COTE D’IVOIRE TOURISME vous donne accès à des informations essentielles pour développer une activité de meublé de tourisme ou de chambre d’hôtes. Nous vous invitons également à contacter la Direction des Relations Extérieures, afin de bénéficier de leur expertise.
                </p>

                <SectionTitle title={"Les informations techniques concernant votre activité"} variant="playfairDisplay"/>

                <h4 className={"font-roboto font-black my-4 text-lg"}>Vous êtes propriétaire d’une chambre d’hôtes ou hébergement chez l’habitant :</h4>

                <p className={"text-justify text-normal my-4"}>
                    Selon le Code du Tourisme, ce sont des chambres meublées situées chez l’habitant en vue d’accueillir des touristes, à titres onéreux, pour une ou plusieurs nuitées, assorties de prestations ;
<br/>
                    La prestation fait l’objet d’une facturation groupée de la nuitée (linge de maison fourni) et du petit déjeuner. Chaque chambre doit donner accès à une salle d’eau et w.c, la loi ne précise pas si celle-ci doit être privative et/ou attenante à la chambre.
                </p>

                <h4 className={"font-roboto font-black my-4 text-lg"}>Vous êtes propriétaire d’un meublé de tourisme :</h4>

                <p className={"text-justify text-normal my-4"}>
                    Selon le code du tourisme, « les meublés de tourisme, une chambre, une villa ou un studio de tourisme meublé, classé, pourvu d’installations domestiques qui est offert en location à une clientèle de passage qui y effectue un séjour caractérisé par une location à la journée, à la semaine ou au moins au mois mais qui n’y élit pas domicile ».
                </p>

                <h4 className={"font-roboto font-black my-4 text-lg"}>La dénomination table d’hôtes indique que le loueur propose un repas à ces hôtes :</h4>

                <ul className="text-normal mb-8 list-disc list-inside">
                    <li className="li2">Un repas servi à la table familiale,</li>
                    <li className="li2">Un seul menu avec des ingrédients du terroir (circuit court-local),</li>
                    <li className="li2">Un prix forfaitaire avec les boissons comprises (avec ou sans alcool),</li>
                    <li className="li2">C’est un complément d’activité par rapport à l’hébergement,</li>
                    <li className="li2">La capacité d’accueil est limitée à celle de l’hébergement.</li>
                </ul>

                <SectionTitle title={"La qualification de votre offre"} variant="playfairDisplay" className={"mt-8"}/>


                <p className="text-normal mb-8 mt-4">
                    Qualifier votre offre est une action essentielle ; cela vous permet d’obtenir un regard d’expert, de bénéficier de services, de vous positionner et c’est avant tout un gage de qualité pour le visiteur.
<br/>
<br/>
                    Il est important de choisir votre label en fonction de vos besoins : les thématiques à aborder, le processus d’obtention, les bénéfices attendus, les services, l’amélioration continue et le coût.
                </p>

                <SectionTitle title={"La taxe de développement touristique "} variant="playfairDisplay" className={"mt-8"}/>

                <p className="text-normal mt-4">
                    Le Code du Tourisme en son article 15 : « Des taxes, redevances et autres droits peuvent être créés au profit du développement touristique. La création, le taux et l’affectation de ces prélèvements sont déterminés par décret pris en conseil des Ministres. »

                    Une taxe de développement a été instaurée sur l’ensemble du territoire national par décret <strong>N° 2007-581 du 20 septembre 2007.</strong>

                    En son <strong>« Article 1er nouveau : le présent décret s’applique aux Etablissements de Tourisme. Sont réputés Etablissements de Tourisme :</strong>
                </p>

                <ul className="text-normal list-disc list-inside pl-4">
                    <li className="li1"><b>Les hôtels, motels et village de vacances&nbsp;;</b></li>
                    <li className="li1"><b>Les restaurants, bar et night clubs&nbsp;;</b></li>
                    <li className="li1"><b>Les agences de voyages&nbsp;; </b></li>
                    <li className="li1"><b>Les agences de location de voitures, cars, bateaux, avions&nbsp;;</b></li>
                    <li className="li1"><b>Les marinas&nbsp;;</b></li>
                    <li className="li1"><b>Les casinos et salles de jeux&nbsp;;</b></li>
                </ul>
                <p className={"text-normal"}><strong>Et d’une façon générale, toute entreprises commerciales offrant à une clientèle touristique des prestations de service à caractère touristique. »</strong></p>

                <p className="text-normal mb-8 mt-4">
                    C’est une taxe de tiers et est prélevée par les socio-professionnels de l’industrie du tourisme auprès des visiteurs et s’applique par nuitée ou consommation, par personne et à partir de 18 ans.
<br/>
<br/>
                    Conformément au décret <strong>N° 2007-582 du 20 septembre 2007</strong> portant création et organisation du Fonds de développement Touristique ses missions sont en article 2 « Le fonds a pour mission de soutenir par ses concours, le développement, la promotion et les investissements touristiques. »
                </p>

            </SectionPage>

        </div>
    );
}
